import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { MaterialApoioService } from './material-apoio.service';


export interface MaterialApoioItemModel {
  titulo: string;
  tipo: 'video' | 'texto';
  link: string;
}

export interface MaterialApoioModel {
  icone: string;
  titulo: string;
  subTitulo: string;
  itens: MaterialApoioItemModel[];
}

@Component({
  selector: 'app-material-apoio',
  templateUrl: './material-apoio.component.html',
  styleUrls: ['./material-apoio.component.css']
})

export class MaterialApoioComponent implements OnInit {

  displayModal = false;
  loading = true;
  modalIndex = 0;
  modalSubtitle = 'Selecione o arquivo que deseja baixar.';
  modalTitle = 'Material de apoio';

  materiaisApoio: MaterialApoioModel[];

  constructor(
    private readonly materialApoioService: MaterialApoioService
  ) { }

  ngOnInit() {
    this.materialApoioService.getMaterialApoio().pipe(
      tap(response => {
        this.materiaisApoio = response;
        this.loading = false;
      })
    ).subscribe();
  }

  openModalArquivos(index: number) {
    this.displayModal = true;
    this.modalIndex = index;
    this.modalTitle = this.materiaisApoio[index].titulo;
    this.modalSubtitle = this.materiaisApoio[index].subTitulo;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/material-apoio/material-apoio.component.ts